import Vue from "vue";
import Router from "vue-router";
import statistics from "../utils/statistics";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

const router = new Router({
  mode: 'history',//去掉#号
  routes: [
    { path: "*", redirect: "/" },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/home")
    },
    // 推广活动
    {
      path: "/promotion",
      name: "promotion",
      component: () => import("@/views/promotion/index")
    },
    // h5活动
    {
      path: "/h5buy",
      name: "h5buy",
      component: () => import("@/views/promotion/h5buy")
    },
    // 批量购买
    {
      path: "/batchBuy",
      name: "batchBuy",
      component: () => import("@/views/promotion/batchBuy")
    },
    // 文章详情
    {
      path: "/article_detail/:id",
      name: "article_detail",
      component: () => import("@/views/articleDetail")
    },
    // 热门标签
    {
      path: "/hot_laber",
      name: "hot_laber",
      component: () => import("@/views/hotLaber")
    },
    // 作者，文章
    {
      path: "/author_detail/:id",
      name: "author_detail",
      component: () => import("@/views/authorDetail")
    },
    // 阅读
    {
      path: "/read",
      name: "read",
      component: () => import("@/views/read/index")
    },
    {
      path: "/read_detail/:id",
      name: "read_detail",
      component: () => import("@/views/read/detail")
    },
    {
      path: "/read_free/:id",
      name: "read_free",
      component: () => import("@/views/read/free-detail")
    },
    // 杂志目录
    {
      path: "/magalog/:id",
      name: "magalog",
      component: () => import("@/views/read/magalog")
    },
    // 音频
    {
      path: "/radio",
      name: "radio",
      component: () => import("@/views/radio/index")
    },
    {
      path: "/radio_detail/:id",
      name: "radio_detail",
      component: () => import("@/views/radio/detail")
    },
    {
      path: "/hot_detail/:id",
      name: "hot_detail",
      component: () => import("@/views/radio/hot-detail")
    },
    // 新皮层
    {
      path: "/new_home",
      name: "new_home",
      component: () => import("@/views/new/home")
    },
    {
      path: "/new/:id",
      name: "new",
      component: () => import("@/views/new/index")
    },
    {
      path: "/new_detail/:id",
      name: "new_detail",
      component: () => import("@/views/new/hot-detail")
    },
    // 购买记录
    {
      path: "/single_copy",
      name: "single_copy",
      component: () => import("@/views/buyRecords/singleCopy")
    },
    // 发票详情
    {
      path: "/voice_detail/:id",
      name: "voice_detail",
      component: () => import("@/views/buyRecords/voiceDetail")
    },
    // 我的关注
    {
      path: "/my_concerns",
      name: "my_concerns",
      component: () => import("@/views/myConcerns/index")
    },
    //我的投票
    {
      path: "/my_vote",
      name: "my_vote",
      component: () => import("@/views/myVote/index")
    },
    {
      path: "/my_vote_detail/:id",
      name: "my_vote_detail",
      component: () => import("@/views/myVote/detail")
    },
    // 我的收藏
    {
      path: "/my_collect",
      name: "my_collect",
      component: () => import("@/views/myCollect/index")
    },
    // 使用帮助
    {
      path: "/help",
      name: "help",
      component: () => import("@/views/help/index")
    },
    // 隐私协议
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("@/views/privacy")
    },
    // 会员权益
    {
      path: "/member",
      name: "member",
      component: () => import("@/views/member/index")
    },
    // 搜索
    {
      path: "/search/:keyword",
      name: "search",
      component: () => import("@/views/search")
    },
    // 招聘
    {
      path: "/recruit",
      name: "recruit",
      component: () => import("@/views/footer/recruit")
    },
    // 广告
    {
      path: "/ad",
      name: "ad",
      component: () => import("@/views/footer/ad")
    },
    // 版权说明
    {
      path: "/copyright",
      name: "copyright",
      component: () => import("@/views/footer/copyright")
    },
    // 用户协议
    {
      path: "/agreement",
      name: "agreement",
      component: () => import("@/views/footer/agreement")
    },
    // 联系我们
    {
      path: "/contact",
      name: "contact",
      component: () => import("@/views/footer/contact")
    },
    // 关于我们
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/footer/about")
    },
    // 兑换
    {
      path: "/exchange",
      name: "exchange",
      component: () => import("@/views/channel/Exchange")
    }
  ]
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === "/") {
    next();
  } else {
    let token = localStorage.getItem("Authorization");
    if (token === "null" || token === "") {
      next("/");
    } else {
      next();
    }
  }
});
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js